// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","container":"styles_container__Wvf37","closeButton":"styles_closeButton__ODdKQ","closeIcon":"styles_closeIcon__GN_om"};